module.exports = __webpack_public_path__ + "assets/img/Entrepreneurs_002.fa0dc8d4-ps.jpg";